
import axios from '../wmsAxios'

/*
 * 机构管理模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/tblInvMovement/save',
        method: 'post',
        data
    })
}

// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/tblInvMovement/delete',
        method: 'post',
        data
    })
}
// 查询分页数据
export const findPage = (data) => {
    return axios({
        url: '/tblInvMovement/findPage',
        method: 'post',
      data
    })
}

// 审批
export const confirmApprove = (data) => {
  return axios({
    url: '/tblInvMovement/approvePlannedMove',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/tblInvMovement.js